module.exports = __webpack_public_path__ + "staticcomp/img/content_3.548cfe2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/5/content_3.jpg
// module id = hfYT
// module chunks = 39